module.exports = __webpack_public_path__ + "26aca9824f1d74d34b765d5ebc1cdab9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/blurred-bg/blurred-bg-4.jpg
// module id = 377
// module chunks = 0